import { useEffect, useRef, useMemo } from 'react';
import H from '@here/maps-api-for-javascript';
import { useSelector } from 'react-redux';
import { colors } from 'global/variables';
import { getMultiJobConnectedStops } from '../../utils/multiJobLineUtils';

const STYLE = {
  strokeColor: colors.multiJobLineColor,
  lineWidth: 4,
};

const NewMultiJobConnectionLines = ({ map, mapData }) => {
  const display = useSelector(({ mapContainer }) => mapContainer.display);
  const groupRef = useRef(null);

  const lines = useMemo(
    () => getMultiJobConnectedStops(mapData, display.selectedTour, display.highlightStop),
    [mapData, display.selectedTour, display.highlightStop],
  );

  useEffect(() => {
    if (!map) return undefined;
    groupRef.current = new H.map.Group();
    map.addObject(groupRef.current);

    return () => {
      if (groupRef.current) {
        groupRef.current.removeAll();
        map.removeObject(groupRef.current);
        groupRef.current = null;
      }
    };
  }, [map]);

  useEffect(() => {
    if (!groupRef.current) return;
    groupRef.current.removeAll();

    lines.forEach(({ from, to }) => {
      const lineString = new H.geo.LineString();
      lineString.pushLatLngAlt(from[1], from[0], 0);
      lineString.pushLatLngAlt(to[1], to[0], 0);
      groupRef.current.addObject(new H.map.Polyline(lineString, { style: STYLE }));
    });
  }, [lines]);

  return null;
};

export default NewMultiJobConnectionLines;
